import {
    chakra,
    Box,
    Flex
} from '@chakra-ui/react';

export const LeftNavBackground = chakra(Box, {
    label: 'LeftNavBackground',
    baseStyle: {
        'display': 'flex',
        'flexDirection': 'column',
        'w': '70px',
        'h': 'calc(100vh - 60px)',
        'boxSizing': 'border-box',
        'bgColor': 'white',
        'fontWeight': 400,
        'letterSpacing': '-0.2px',
        'position': 'relative',
        'fontSize': '13px',
        'mt': '60px',
        'boxShadow': '0 10px 8px 0 rgba(15, 25, 42, 0.16)',
        'zIndex': 1001,
        'overflowY': 'auto',
        'overflowX': 'hidden',
        '&::-webkit-scrollbar': { width: '0' }
    }
});

export const ProductLogo = chakra(Flex, {
    label: 'LeftNavProductLogo',
    baseStyle: {
        flex: 1,
        flexDirection: 'column-reverse',
        mb: '10px',
        alignItems: 'center'
    }
});
